__turbopack_context__.v({
  "item": "_14jtiG_item",
  "navigation": "_14jtiG_navigation",
});
